// extracted by extract-css-chunks-webpack-plugin
module.exports = {"App":"app-styles__App--1s_U5"};